import { z } from 'zod';
import { CharacterPortraitSchema } from './party.js';
/**
 * The ladder (ADR 0082), over HTTP with a character session: a board read
 * now and then, outside any room, like the auction house.
 */
export const LADDER_BOARDS = ['xp', 'dps'];
/** The whole server, or only the reader's friends, or only their guild; the reader is in each. */
export const LADDER_SCOPES = ['all', 'friends', 'guild'];
export const LadderQuerySchema = z.object({
    board: z.enum(LADDER_BOARDS).default('xp'),
    scope: z.enum(LADDER_SCOPES).default('all'),
});
export const LadderEntrySchema = z.object({
    rank: z.number().int().min(1),
    name: z.string(),
    classId: z.string(),
    level: z.number().int().min(1),
    xp: z.number().int().min(0),
    /** The sheet's, crits included; null for a character not measured since the ladder exists. */
    dps: z.number().min(0).nullable(),
    /** The guild's tag, as the name plate shows it. */
    guild: z.string().nullable(),
    /** The reader's own line. */
    self: z.boolean(),
    /** The head as they are dressed, online or not: what the friends' list draws. */
    portrait: CharacterPortraitSchema,
});
export const LadderSchema = z.object({
    board: z.enum(LADDER_BOARDS),
    scope: z.enum(LADDER_SCOPES),
    /** The first `LADDER_SIZE`, best first. */
    entries: z.array(LadderEntrySchema),
    /** The reader's line when it is below them; null when it is among them, or unranked (an admin). */
    mine: LadderEntrySchema.nullable(),
    /** How many characters this board ranks. */
    total: z.number().int().min(0),
});
//# sourceMappingURL=ladder.js.map